import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx } from "react/jsx-runtime";
var PhoneSvg = function PhoneSvg() {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m8.357 2.249 2.107 7.375-4.28 2.556a18.2 18.2 0 0 0 2.604 3.28v.001c.991.992 2.092 1.866 3.282 2.605l2.556-4.281L22 15.892l-.761 6.357-.68-.037a19.6 19.6 0 0 1-8.596-2.518 19.7 19.7 0 0 1-4.203-3.205 19.7 19.7 0 0 1-3.204-4.203 19.6 19.6 0 0 1-2.52-8.595L2 3.01zm4.979 16.533a18.2 18.2 0 0 0 6.624 1.928l.45-3.76-5.109-1.46zm-7.868-7.868a18.2 18.2 0 0 1-1.93-6.624L7.3 3.84l1.46 5.109z",
      clipRule: "evenodd"
    })
  });
};
export var Phone = function Phone(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: PhoneSvg
  }));
};